
import VeeValidate from 'vee-validate';
import api from './api';

const configureValidation = () => {
  VeeValidate.Validator.extend('decimal_between', {
    getMessage: (field, params) => `The ${field} field must be numeric and contain between ${params[0]} and ${params[1]} decimal places.`,
    validate: (value, params) => {
      if (Number.isNaN(value)) return false;
      if (value.indexOf('.') !== -1) {
        const numDecimal = value.split('.')[1].length;
        return numDecimal >= Number(params[0]) && numDecimal <= Number(params[1]);
      }
      return false;
    },
  });

  VeeValidate.Validator.extend('min_money', {
    getMessage: (field, params) => `The ${field} field must be $${params[0]} or more.`,
    validate: (value, params) => {
      if (Number.isNaN(value)) return false;
      return Number(value) >= Number(params[0]);
    },
  });

  VeeValidate.Validator.extend('multi_required', {
    getMessage: field => `At least one ${field} is required.`,
    validate: (value) => {
      if (value) return { valid: value.length > 0, data: { required: true } };
      return { valid: false, data: { required: true } };
    },
  },
  {
    computesRequired: true,
  });

  VeeValidate.Validator.extend('at_least_two_required', {
    getMessage: field => `At least two ${field}s are required.`,
    validate: (value) => {
      if (value) return { valid: value.length > 1, data: { required: true } };
      return { valid: false, data: { required: true } };
    },
  },
  {
    computesRequired: true,
  });

  VeeValidate.Validator.extend('requestor_role_required', {
    getMessage: 'Requestor role is required.',
    validate: (value) => {
      if (value) return { valid: value.includes(39), data: { required: true } };
      return { valid: false, data: { required: true } };
    },
  },
  {
    computesRequired: true,
  });

  VeeValidate.Validator.extend('single_required', {
    getMessage: field => `Only one ${field} is allowed.`,
    validate: (value) => {
      if (value) return { valid: value.length > 0 && value.length < 2, data: { required: true } };
      return { valid: false, data: { required: true } };
    },
  },
  {
    computesRequired: true,
  });


  VeeValidate.Validator.extend('project_exists', {
    getMessage: 'Project not found.',
    validate: (value, params) => new Promise((resolve) => {
      const entityType = params != null && params.length > 0 ? params[0] : 'project';
      api.get(`/${entityType}/${value}/exists`)
        .then(response => resolve(response.data));
    }),
  },
  {
    immediate: false,
  });

  VeeValidate.Validator.extend('current_property_exists', {
    getMessage: 'Property was not found or is not Current.',
    validate: value => new Promise((resolve) => {
      api.get(`/property/${value}/currentexists`)
        .then(response => resolve(response.data));
    }),
  },
  {
    immediate: false,
  });

  VeeValidate.Validator.extend('unique', {
    getMessage: field => `The value in the ${field} fields cannot be duplicated.`,
    validate: (value, params) => {
      if (!params) {
        return true;
      }
      if (params.filter(entry => Number(entry) === Number(value)).length > 1) {
        return false;
      }
      return true;
    },
  },
  {
    immediate: false,
  });

  VeeValidate.Validator.extend('max_decimal', {
    getMessage: (field, params) => `The ${field} field must be numeric and may contain up to ${params[0]} decimal places.`,
    validate: (value, params) => {
      if (Number.isNaN(Number(value))) return false;
      const stringValue = value.toString();
      if (stringValue.indexOf('.') !== -1) return stringValue.split('.')[1].length <= Number(params[0]);
      return true;
    },
  });

  VeeValidate.Validator.extend('min_value_if', {
    getMessage: (field, [otherField]) => `The ${field} field must be greater than 0 when ${otherField} is greater than 0.`,
    validate: (value, [otherField]) => {
      if (otherField > 0) {
        return value > 0;
      }
      return true;
    },
  },
  {
    hasTarget: true,
  });

  VeeValidate.Validator.extend('whole_number', {
    getMessage: field => `The ${field} field must be a whole number.`,
    validate: value => Number.isInteger(Number(value)),
  });

  VeeValidate.Validator.extend('previous_service_id_exists', {
    getMessage: 'Invalid Previous Service ID.',
    validate: value => new Promise((resolve) => {
      api.get(`/service/previousserviceidexists/${value}`)
        .then(response => resolve(response.data));
    }),
  },
  {
    immediate: true,
  });

  VeeValidate.Validator.extend('has_no_open_reviews', {
    getMessage: 'The Status cannot be set to Active if there are Open Reviews.',
    validate: (value, params) => {
      if (value !== 2) {
        return true;
      }
      if (params
          && params.some(e => e.reviewStatusId === 1)) {
        return false;
      }
      return true;
    },
  });
};

export default configureValidation;
